import { Component, Input, OnInit } from '@angular/core';
import { CargandoService } from './cargando.service';

@Component({
  selector: 'app-cargando',
  templateUrl: './cargando.component.html',
  styleUrls: ['./cargando.component.scss'],
})
export class CargandoComponent implements OnInit {

  @Input() tipo: string;
  @Input() ancho: string;
  @Input() alto: string;
  @Input() id: string;

  spinnerActivo = false;
  constructor(private cargandoService: CargandoService) {
  }

  async ngOnInit() {
    this.cargandoService.add(this.id);
    this.cargandoService.get(this.id).subscribe(
      data => {
        this.spinnerActivo = data;
      }
    );
  }
}

